import CompanyLocationsSerializers from '../serializers/CompanyLocationsSerializers';
import {CompanyProfile} from '../types';

import * as api from '../../../../lib/api/v1/index';
import {forceLogout} from '../../../../services/auth-service';

export class CompanyLocationsService {
  async getCompanyLocations(companyId: string): Promise<{locations: CompanyProfile['locations']}> {
    try {
      const response = await api.getCompanyLocations(companyId);
      if (response.ok) {
        const payload = await response.json();
        return CompanyLocationsSerializers.toObject(payload);
      }
      if (response.status === 401) {
        forceLogout();
      }
      throw new Error('Could not get company locations');
    } catch (error: unknown) {
      console.error('This is the error:', error);
      throw new Error('Could not get company locations');
    }
  }

  async updateCompanyLocations(
    companyId: string,
    companyLocations: CompanyProfile['locations']
  ): Promise<{locations: CompanyProfile['locations']}> {
    try {
      const response = await api.updateCompanyLocations(companyId, companyLocations);
      if (response.ok) {
        const payload = await response.json();
        return CompanyLocationsSerializers.toObject(payload);
      }
      if (response.status === 401) {
        forceLogout();
      }
      throw new Error('Could not update company profile');
    } catch (error: unknown) {
      console.error('This is the error:', error);
      throw new Error('Could not update company locations');
    }
  }

  async createCompanyLocations(
    companyId: string,
    companyLocations: CompanyProfile['locations']
  ): Promise<{locations: CompanyProfile['locations']}> {
    try {
      const response = await api.createCompanyLocations(companyId, companyLocations);
      if (response.ok) {
        const payload = await response.json();
        return CompanyLocationsSerializers.toObject(payload);
      }
      if (response.status === 401) {
        forceLogout();
      }
      throw new Error('Could not update company profile');
    } catch (error: unknown) {
      console.error('This is the error:', error);
      throw new Error('Failed to create location');
    }
  }

  async deleteCompanyLocations(companyId: string, locationIds: string[]) {
    try {
      await api.deleteCompanyLocations(companyId, locationIds);
    } catch (error: unknown) {
      console.error('This is the error:', error);
      throw new Error('Failed to delete location(s)');
    }
  }
}
